// „Neues Passwort senden“ für bestehende Portalzugänge (Mieter/Eigentümer): Passwort wählen → bestätigen → Mail.
import { useState } from 'react';
import { EnvelopeSimple, Eye, EyeSlash, Key, Sparkle } from '@phosphor-icons/react';
import { BestaetigenDialog, ImmoButton, TextFeld } from '../immobilien/ui';
import { passwortFehler, passwortVorschlag } from '../../lib/immobilien/portal';
import { sendeZugangsdaten, zugangsMeldung } from '../../lib/portal/zugangsdaten';

export function NeuesPasswortSenden({ rolle, id, email, zeige }: { rolle: 'mieter' | 'eigentuemer'; id: string; email: string; zeige: (t: string, fehler?: boolean) => void }) {
  const [offen, setOffen] = useState(false);
  const [passwort, setPasswort] = useState('');
  const [sichtbar, setSichtbar] = useState(true);
  const [fragen, setFragen] = useState(false);
  const [laeuft, setLaeuft] = useState(false);
  const fehler = passwort ? passwortFehler(passwort) : null;
  const senden = async () => {
    setLaeuft(true);
    try {
      const r = await sendeZugangsdaten({ rolle, id, passwort, neuSetzen: true });
      zeige(zugangsMeldung(r, false), !r.gesendet);
      setOffen(false); setPasswort('');
    } catch (e) { zeige(`Nicht gesendet: ${(e as Error).message}`, true); }
    finally { setLaeuft(false); setFragen(false); }
  };
  if (!offen) {
    return <ImmoButton icon={Key} onClick={() => { setPasswort(passwortVorschlag()); setOffen(true); }}>Neues Passwort senden</ImmoButton>;
  }
  return (
    <div className="flex flex-col" style={{ gap: 10, padding: 12, borderRadius: 18, background: 'var(--fill)', width: '100%' }}>
      <div className="flex items-end flex-wrap" style={{ gap: 8 }}>
        <div style={{ flex: '1 1 220px' }}>
          <TextFeld label="Neues Passwort" type={sichtbar ? 'text' : 'password'} wert={passwort} onChange={setPasswort} autoComplete="new-password" fehler={fehler ?? undefined} />
        </div>
        <ImmoButton groesse={48} pille={false} icon={sichtbar ? EyeSlash : Eye} aria-label={sichtbar ? 'Passwort verbergen' : 'Passwort anzeigen'} onClick={() => setSichtbar((v) => !v)} />
        <ImmoButton groesse={48} pille={false} icon={Sparkle} onClick={() => setPasswort(passwortVorschlag())}>Vorschlagen</ImmoButton>
      </div>
      <span style={{ fontSize: 12, color: 'var(--ink3)' }}>Das alte Passwort gilt danach nicht mehr. Die E-Mail an {email} enthält das neue Passwort im Klartext mit der Bitte, es nach der Anmeldung zu ändern.</span>
      <div className="flex flex-wrap justify-end" style={{ gap: 8 }}>
        <ImmoButton art="glas" disabled={laeuft} onClick={() => setOffen(false)}>Abbrechen</ImmoButton>
        <ImmoButton art="akzent" icon={EnvelopeSimple} disabled={laeuft || !passwort || !!fehler} onClick={() => setFragen(true)}>Passwort setzen &amp; senden</ImmoButton>
      </div>
      {fragen && (
        <BestaetigenDialog titel="Neues Passwort senden?" icon={EnvelopeSimple} gefahr={false} laeuft={laeuft}
          text={`Das Passwort wird geändert und per E-Mail an ${email} geschickt.`} bestaetigenLabel="Senden"
          onBestaetigen={() => void senden()} onAbbrechen={() => setFragen(false)} />
      )}
    </div>
  );
}
